import { Comment,OperationLog} from '@/common/model';
import { registerMock } from '@/utils/mockRegistry';
import {Demand} from './model'; // 请确保根据您的文件结构调整导入路径

const mockComments: Comment[] = [
  {
    id: 1,
    content: '这个需求很紧急，需要尽快处理。',
    fromUserId: 5,
    fromUserName: '罗炳',
    toUserid: 2,
    toUserName: '李四',
    replyToId: 0,
    createTime: new Date('2023-06-10T10:20:30Z'),
    updateTime: new Date('2023-06-10T10:20:30Z')
  },
  {
    id: 2,
    content: '已经完成了第一部分。',
    fromUserId: 5,
    fromUserName: '罗炳',
    toUserid: 1,
    toUserName: '张三',
    replyToId: 1,
    createTime: new Date('2023-06-12T14:30:45Z'),
    updateTime: new Date('2023-06-12T14:30:45Z')
  }
];

const mockOperationLogs: OperationLog[] = [
  {
    id: 1,
    operatorId: 1,
    operatorName: '张三',
    content: '创建了需求。',
    logTime: new Date('2023-06-05T09:00:00Z')
  },
  {
    id: 2,
    operatorId: 2,
    operatorName: '李四',
    content: '更新了需求状态。',
    logTime: new Date('2023-06-06T10:00:00Z')
  }
];

const mockDemandList: Demand[] = [
  {
    id: 1, 
    content: '实现用户登录功能',
    submitterId: 5,
    submitterName: '汤波',
    executorId: 2,
    executorName: '李四',
    submitTime: new Date('2023-06-05T09:00:00Z'),
    status: 1,
    comments: mockComments,
    logs: mockOperationLogs
  },
  {
    id: 2, 
    content: '优化页面加载速度',
    submitterId: 5,
    submitterName: '罗炳',
    executorId: 3,
    executorName: '王五',
    submitTime: new Date('2023-06-06T10:00:00Z'),
    status: 2,
    comments: [],
    logs: []
  },
  {
    id: 3, 
    content: '添加支付接口',
    submitterId: 3,
    submitterName: '王五',
    executorId: 1,
    executorName: '张三',
    submitTime: new Date('2023-06-07T11:00:00Z'),
    status: 2,
    comments: [],
    logs: []
  },
  {
    id: 4, 
    content: '修复登录页面的bug',
    submitterId: 5,
    submitterName: '张三',
    executorId: 2,
    executorName: '李四',
    submitTime: new Date('2023-06-08T12:00:00Z'),
    status: 1,
    comments: mockComments,
    logs: mockOperationLogs
  },
  {
    id: 5, 
    content: '重构后台管理系统',
    submitterId: 2,
    submitterName: '李四',
    executorId: 3,
    executorName: '王五',
    submitTime: new Date('2023-06-09T13:00:00Z'),
    status: 0,
    comments: [],
    logs: []
  }
];

export default mockDemandList;


export const registerMocks = ()=>{
    registerMock("demandList", mockDemandList);
}